export const validImageExtensions = ['jpg', 'jpeg', 'png', 'gif']
export const validVideoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'wmv', 'flv', 'webm', 'mts' , 'm2ts']

export const MAX_VIDEO_SIZE_MB = 20 // 20 MB
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024